import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import Menu from "./Menu";
import Booking from "./Booking";
import Slider from "./Slider";
import Dataentry from "./Dataentry";
import SiteFooter from "./SiteFooter";
import axios from 'axios';
import Popup from './Popup';
import Rolling from "./Rolling";
import Events from "./Events";

// const API_BASE = "http://localhost/myapp/api/uploads";

const API_BASE = "https://spst.in/myapp/api/uploads";

function Home() {

	const [uploads, setUploads] = useState([]);
	const [editId, setEditId] = useState(null);
	const [editName, setEditName] = useState('');

	useEffect(() => {
		fetchUploads();
	}, []);

	const fetchUploads = async () => {
		const res = await axios.get(`${API_BASE}/get.php`);
		setUploads(res.data);
	};

	const handleDelete = async (id) => {
		if (!window.confirm("Delete this record?")) return;
		await axios.post(`${API_BASE}/delete.php`, { id });
		fetchUploads();
	};

	const startEdit = (item) => {
		setEditId(item.id);
		setEditName(item.name);
	};

	const saveEdit = async () => {
		await axios.post(`${API_BASE}/update.php`, { id: editId, name: editName });
		setEditId(null);
		fetchUploads();
	};



	return (
		<div>
			<div className="row slider" style={{ backgroundImage:'url(./images/bg.jpg)', backgroundSize: 'cover', backgroundPosition: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row' }}>
				{/* <div className="container"></div> */}
				<div style={{ position: '', zIndex: '9999', }}>
					{/* <Popup /> */}
				</div>
				
				<div className="row">
					<div className="col-md-8" style={{ width: '800px', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingLeft: '15%', flexDirection: 'column' }} >
						<h1 className="highhead">Parama Bhattaraka Sree Chattambiswami Smaraka</h1>
						<h1 className="tophead">Abhedasramam <br /> Mahamanthralayam</h1>
					</div>
					<div className="col-md-4" style={{ width: '800px' }}>
						<img src="./images/gurudev-1.jpeg" alt="Gurudev" style={{ width: '100%' }} />

					</div>
				</div>
			</div>
			{/* <!-- Sections --> */}


			<Slider />
			<Rolling />
			<Events />
			{/* <div className="container" style={{ display: 'flex', width: '100%', marginBottom: '0px' }}>
				<div className="col-md-2" style={{ background: 'orange', color: 'maroon', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
					<h4 style={{ fontWeight: '600', color: 'maroon' }}>Latest Updates</h4>
				</div>
				<div className="col-md-10" style={{ background: 'maroon', padding: '5px' }}>
					
					<Marquee speed={50} gradient={false} pauseOnHover>

						<div class="news_post_title"><span style={{ color: 'white', cursor: 'pointer' }}>തിരുവനന്തപുരം അഭേദാശ്രമത്തിൽ നിന്നുമുള്ള തീർത്ഥയാത്രകൾ
							ഫെബ്രുവരി 13 - 14 : ശബരിമല</span> &nbsp;&nbsp;| &nbsp;&nbsp; </div>
							<div class="news_post_title"><span style={{ color: 'white', cursor: 'pointer' }}>മാർച്ച് 8 : പഞ്ചപാണ്ഡവർ പ്രതിഷ്ഠിച്ച മഹാവിഷ്ണു ക്ഷേത്രങ്ങൾ 
മേയ് 9 - 13 : തിരുപ്പതി, കാളഹസ്തി </span> &nbsp;&nbsp;| &nbsp;&nbsp;</div>
						<div class="news_post_title"><span style={{ color: 'white', cursor: 'pointer' }} ><Link to="Emagazine" className="menuitems" style={{ textAlign: "center" }}>
							<p className="menuitems">E-Magazine | Read Online</p>
						</Link></span></div>
					</Marquee>
				</div>
			</div> */}
			{/* <div class="container">
			
			 <div className="marquee-container">
      <div className="marquee-bounce">
        🚀 Website updation is going on... 🚀
      </div>
    </div>
		</div> */}



			<div class="grouped_sections" style={{ backgroundImage: 'url(./images/bg.jpg)', backgroundSize: 'cover', backgroundAttachment: 'fixed' }}>

				<div class="container">
					<div class="row">

						{/* <!-- Why Choose Us --> */}

						<div class="col-lg-8 grouped_col" style={{ background: 'rgba(0, 0, 0, 0.6)', padding: '35px' }}>
							<h1 style={{ color: 'orange', fontSize: '30pt' }}>Satgurudev</h1>
							<p style={{ color: 'white', fontSize: '12pt', textAlign: 'justify' }}>Everyone who was blessed to contact Swami Abhedananda once in life should have felt his astounding equanimity, innocence, humility, endearing traits and versatility.

								Abheda one without any “Bhed” or difference or discrimination.

								He was the living example of the dictum that the beauty of man lay in the beauty of his mind. He used to make his devotees wonder – was he ‘love’ personified? He deeply and sincerely loved one and all who contacted him. He made each of his devotees feel special. The flowing nectar of Gurudev’s love is always perennial, inexhaustible and boundless.</p>

						</div>

						{/* <!-- Events --> */}



						{/* <!-- News --> */}

						<div class="col-lg-4 grouped_col" style={{ background: 'rgba(237, 237, 237, 0.99)', padding: '35px' }}>
							<img src="./images/gurudev-1.jpeg" alt="Gurudev" style={{ width: '100%' }} />

						</div>
					</div>
				</div>
			</div>


			{/* <div className="gosala">
			<div className="overlay">
				<div class="gosaladonate">
					<Link to="https://booking.sreepadmanabhaswamytemple.org/Murajepam.aspx" className="btn btn-primary" style={{padding:'20px',background:'orange',color:'maroon',fontSize:'14pt',fontWeight:'400',border:'1px solid orange'}}>Goshala Donation</Link>
					<Link to="https://booking.sreepadmanabhaswamytemple.org/GoldenGrace.aspx" className="btn btn-primary" style={{padding:'20px',background:'orange',color:'maroon',fontSize:'14pt',fontWeight:'400',border:'1px solid orange'}}>Donate Golden Grace & Grandeur</Link>
				</div>
				
				
			</div>
			
	</div> */}




		</div>

	);
}

export default Home;